import { InputModel } from "../../../../../../../../utils/types";
import { SearchTitleInput } from "../../searchTitleInput";

export const size6 = {
    xl: 6,
    lg: 6,
    md: 6,
    sm: 6,
    xs: 6,
}
export const size12 = {
    xl: 12,
    lg: 12,
    md: 12,
    sm: 12,
    xs: 12,
}

export const inputUser: Record<string, InputModel> = {
    search: {
        label: 'general.searchUsers',
        translate: true,
        name: 'search',
        value: null,
    },
    from: {
        label: 'general.tags.from',
        translate: true,
        name: 'from',
        type: 'date',
        value: null,
        rest: {
            max: 'to',
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
            xs: 6,
        },
    },
    to: {
        label: 'general.tags.to',
        translate: true,
        name: 'to',
        type: 'date',
        value: null,
        rest: {
            min: 'from',
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
            xs: 6,
        },
    },
    role: {
        label: 'general.tags.role',
        translate: true,
        name: 'role',
        type: 'filter-select',
        items: [],
        value: null,
    },
    stores: {
        label: 'general.tags.store',
        translate: true,
        name: 'stores',
        type: 'filter-select',
        items: [],
        value: null,
    },
    division_ids: {
        label: 'general.tags.divisions',
        translate: true,
        name: 'division_ids',
        type: 'filter-select',
        items: [],
        value: null,
    },
    userType: {
        label: 'general.tags.userType',
        translate: true,
        name: 'userType',
        type: 'filter-select',
        items: [],
        value: null,
    },
    area: {
        label: 'general.tags.area',
        translate: true,
        name: 'area',
        type: 'filter-select',
        items: [],
        value: null,
    },
    department: {
        label: 'general.tags.department',
        translate: true,
        name: 'department',
        type: 'filter-select',
        items: [],
        value: null,
    },
}

export const inputActivity: Record<string, InputModel> = {
    title: {
        label: 'general.tags.title',
        translate: true,
        name: 'title',
        value: null,
        size: size12
    },
    from: {
        label: 'general.initDate',
        translate: true,
        name: 'from',
        type: 'date',
        validate: { required: true, range: true },
        rest: {
            max: 'to',
        },
        size: size6,
    },
    to: {
        label: 'general.finishDate',
        translate: true,
        name: 'to',
        type: 'date',
        validate: { required: true, range: true },
        rest: {
            min: 'from',
        },
        size: size6,
    },
    activityType: {
        label: 'general.tags.activityType',
        translate: true,
        name: 'activityType',
        type: 'filter-select',
        validate: { required: true },
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size6,
    },
}
export const inputActivityMySelf: Record<string, InputModel> = {
    ...inputActivity,
    observation: {
        label: 'general.observation',
        translate: true,
        name: 'observation',
        type: 'textArea',
        size: size12,
        rest: {
            rows: 4,
            maxRows: 4
        }
    },
}

export const inputUserMap: Record<string, InputModel> = {
    search: {
        label: 'general.search',
        translate: true,
        name: 'search',
        size: size12,
        wrapChildren: ({children,id})=>{
          return(
           <SearchTitleInput children={children} id={id} title='Filtros por usuario'/>
          )
        }
    },
    role: {
        label: 'general.tags.role',
        translate: true,
        name: 'role',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
    division: {
        label: 'general.tags.division',
        translate: true,
        name: 'division',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
    user: {
        label: 'general.tags.user',
        translate: true,
        name: 'user',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
    userType: {
        label: 'general.tags.userType',
        translate: true,
        name: 'userType',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
    area: {
        label: 'general.tags.area',
        translate: true,
        name: 'area',
        type: 'filter-select',
        items: [],
        value: null,
    },
    department: {
        label: 'general.tags.department',
        translate: true,
        name: 'department',
        type: 'filter-select',
        items: [],
        value: null,
    },

    searchActivity: {
        label: 'general.search',
        translate: true,
        name: 'search_activity',
        size: size12,
        wrapChildren: ({children,id})=>{
          return(
           <SearchTitleInput children={children} id={id} title='Filtros por actividad'/>
          )
        }
    },
    status: {
        label: 'general.tags.status',
        translate: true,
        name: 'status',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
    from: {
        label: 'general.tags.from',
        translate: true,
        name: 'from',
        type: 'date',
        validate: { range: true },
        rest: {
            max: 'to',
        },
        size: size6,
    },
    to: {
        label: 'general.tags.to',
        translate: true,
        name: 'to',
        type: 'date',
        validate: { range: true },
        rest: {
            min: 'from',
        },
        size: size6,
    },
    stores: {
        label: 'general.tags.store',
        translate: true,
        name: 'store_activity_ids',
        type: 'filter-select',
        items: [],
        value: null,
    },
}

export const inputOneUserMap: Record<string, InputModel> = {
    search: {
        label: 'general.tags.searchByTitle',
        translate: true,
        name: 'search_activity',
        size: size12,
    },
    status: {
        label: 'general.tags.status',
        translate: true,
        name: 'status',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
    year: {
        label: 'general.filterDate.year',
        translate: true,
        name: 'year',
        type: 'filter-select',
        items: [],
        value: null,
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
            xs: 6,
        },
    },
    month: {
        label: 'general.filterDate.month',
        translate: true,
        name: 'month',
        type: 'filter-select',
        items: [],
        value: null,
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
            xs: 6,
        },
    },
    from: {
        label: 'general.tags.from',
        translate: true,
        name: 'from',
        type: 'date',
        validate: { range: true },
        rest: {
            max: 'to',
        },
        size: size6,
    },
    to: {
        label: 'general.tags.to',
        translate: true,
        name: 'to',
        type: 'date',
        validate: { range: true },
        rest: {
            min: 'from',
        },
        size: size6,
    },
    area: {
        label: 'general.tags.area',
        translate: true,
        name: 'area',
        type: 'filter-select',
        items: [],
        value: null,
    },
    department: {
        label: 'general.tags.department',
        translate: true,
        name: 'department',
        type: 'filter-select',
        items: [],
        value: null,
    },
    stores: {
        label: 'general.tags.storeId',
        translate: true,
        name: 'stores',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
}

export const inputDestinations: Record<string, InputModel> = {
    search: {
        label: 'general.tags.search_destination',
        translate: true,
        name: 'search',
        size: size12,
        wrapChildren: ({children,id})=>{
          return(
           <SearchTitleInput children={children} id={id} title='Filtros'/>
          )
        }
    },
    from: {
        label: 'general.tags.from',
        translate: true,
        name: 'from',
        type: 'date',
        validate: { range: true },
        rest: {
            max: 'to',
        },
        size: size6,
    },
    to: {
        label: 'general.tags.to',
        translate: true,
        name: 'to',
        type: 'date',
        validate: { range: true },
        rest: {
            min: 'from',
        },
        size: size6,
    },
    user: {
        label: 'general.tags.user',
        translate: true,
        name: 'user',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
    role: {
        label: 'general.tags.role',
        translate: true,
        name: 'role',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
}

export const inputUserListMap: Record<string, InputModel> = {
    ...inputOneUserMap,
    user: {
        label: 'general.tags.user',
        translate: true,
        name: 'user',
        type: 'filter-select',
        items: [
            {
                label: 'option',
                value: 'option'
            }
        ],
        value: null,
        size: size12,
    },
}

export const inputFilterUser: Record<string, InputModel> = {
    area: {
        label: 'general.tags.area',
        translate: true,
        name: 'area',
        type: 'filter-select',
        items: [],
        value: null,
    },
    department: {
        label: 'general.tags.department',
        translate: true,
        name: 'department',
        type: 'filter-select',
        items: [],
        value: null,
    },
}
